interface ProblemDetails {
  title?: string;
  errors?: Record<string, string[]>;
}

// The service answers errors with (Validation)ProblemDetails, which Backstage's ResponseError
// doesn't read, so build the message from `title` and the validation `errors` ourselves.
export const problemDetailsMessage = async (
  response: Response,
): Promise<string> => {
  const fallback =
    `Request failed with ${response.status} ${response.statusText}`.trim();

  try {
    const { title, errors }: ProblemDetails = await response.json();
    const details = Object.values(errors ?? {}).flat();
    return [title ?? fallback, ...details].join(' ');
  } catch {
    return fallback;
  }
};
